<template>
  <div ref="ps" class="paySuccess">
    <template v-if="isSuccess !== undefined">
      <i class="el-icon-success success" v-if="isSuccess"></i>
      <i class="el-icon-error fail" v-if="!isSuccess"></i>
      <h3>
        订单支付{{ isSuccess ? '完成' : '失败' }}
        <p v-if="!isSuccess">订单状态可能延迟，请刷新订单详情</p>
      </h3>
      <el-button type="primary" @click="toDetail" v-if="orderId"
        >查看订单</el-button
      >
    </template>
  </div>
</template>

<script>
export default {
  data () {
    return {
      outTradeNo: '',
      loading: undefined,
      orderId: undefined,
      isSuccess: undefined
    }
  },
  created () {
    const { out_trade_no, orderId } = this.$route.query
    // this.outTradeNo = "D1668215186949480450";
    this.outTradeNo = out_trade_no
    this.orderId = orderId
  },
  mounted () {
    this.loading = this.$loading({
      lock: true,
      text: '确认支付中...',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.7)'
    })
    if (this.outTradeNo) this.getOrderId()
    else this.getOrderDetail()
  },
  methods: {
    toDetail () {
      this.$router.replace({
        name: 'orderDetail',
        params: {
          id: this.orderId
        }
      })
    },
    getOrderId () {
      this.$http
        .get(
          `/front/payment/payOrderRecord/getOrderIdByOrderRecordCode?orderRecordCode=${this.outTradeNo}`
        )
        .then(({ data: { code, data } }) => {
          if (+code === 0) {
            this.orderId = data
            this.getOrderDetail()
          } else {
            this.isSuccess = false
            this.loading.close()
          }
        })
    },
    getOrderDetail () {
      this.$http
        .get(
          `/front/consumer/shopping/order/orderInfo/${this.orderId}/false/0/0`
        )
        .then(({ data: { code, data } }) => {
          if (+code === 0) {
            this.isSuccess = +data.payStatus === 29
          } else {
            this.isSuccess = false
          }
          this.loading.close()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.paySuccess {
  height: 640px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 48px;

  h3 {
    font-size: 36px;
    margin: 48px;
    text-align: center;
  }

  p {
    margin: 48px;
    font-size: 24px;
  }

  .success {
    font-size: 100px;
    color: #1989fa;
  }

  .fail {
    font-size: 100px;
    color: #ee0a24;
  }
}
</style>
